export const FORNECEDORES = [
  { id: 'uralchem', label: 'Uralchem' },
  { id: 'acron',    label: 'Acron' },
  { id: 'sabic',    label: 'Sabic' },
  { id: 'phosagro', label: 'Phosagro' },
  { id: 'china',    label: 'China' },
  { id: 'outros',   label: 'Outros' },
];

export const getUreiaSaldos = (day) => {
  const saldos = {};
  FORNECEDORES.forEach(f => {
    const ur = day.ureia?.[f.id];
    if (ur && typeof ur === 'object') {
      saldos[f.id] = (ur.saldo_ini || 0) + (ur.entrada || 0) - (ur.consumo || 0);
    } else {
      saldos[f.id] = ur || 0;
    }
  });
  return saldos;
};

export const EMB_CV = [
  { id: 'bomb20v', label: 'Bombona 20L Vazia', unit: 'un', produz: true  },
  { id: 'bomb5v',  label: 'Bombona 5L Vazia',  unit: 'un', produz: false },
  { id: 'tampa',   label: 'Tampa',              unit: 'un', produz: false },
  { id: 'ibc_vz',  label: 'IBC Vazio',          unit: 'un', produz: false },
];

export const EMB_SINOP = [
  { id: 'bomb20v', label: 'Bombona 20L Vazia', unit: 'un', produz: false },
  { id: 'bomb5v',  label: 'Bombona 5L Vazia',  unit: 'un', produz: false },
  { id: 'tampa',   label: 'Tampa',              unit: 'un', produz: false },
  { id: 'ibc_vz',  label: 'IBC Vazio',          unit: 'un', produz: false },
];

// Produtos acabados — Campo Verde
export const ARLA_CV = [
  { id: 'bomb20',        label: 'Bombona 20L',           unit: 'un' },
  { id: 'bomb5',         label: 'Bombona 5L',             unit: 'un' },
  { id: 'ibc1000',       label: 'IBC 1000L',              unit: 'L'  },
  { id: 'granel',        label: 'Granel',                 unit: 'L'  },
  { id: 'arlaInter',     label: 'Arla Intermediário',     unit: 'L'  },
  { id: 'arlaCaminhoes', label: 'Arla Tanques Caminhões', unit: 'L'  },
  { id: 'aerem20',       label: 'Aerem EVO 20L',          unit: 'un' },
  { id: 'aerem5',        label: 'Aerem EVO 5L',           unit: 'un' },
];

// Produtos acabados — Sinop
export const ARLA_SINOP = [
  { id: 'bomb20',        label: 'Bombona 20L',           unit: 'un' },
  { id: 'bomb5',         label: 'Bombona 5L',             unit: 'un' },
  { id: 'ibc1000',       label: 'IBC 1000L',              unit: 'L'  },
  { id: 'granel',        label: 'Granel',                 unit: 'L'  },
  { id: 'arlaInter',     label: 'Arla Intermediário',     unit: 'L'  },
  { id: 'arlaCaminhoes', label: 'Arla Tanques Caminhões', unit: 'L'  },
  { id: 'aerem20',       label: 'Aerem EVO 20L',          unit: 'un' },
  { id: 'aerem5',        label: 'Aerem EVO 5L',           unit: 'un' },
];

// Lista completa — usada internamente no getSaldo
export const ARLA = [
  { id: 'bomb20',        label: 'Bombona 20L',           unit: 'un' },
  { id: 'bomb5',         label: 'Bombona 5L',             unit: 'un' },
  { id: 'ibc1000',       label: 'IBC 1000L',              unit: 'L'  },
  { id: 'granel',        label: 'Granel',                 unit: 'L'  },
  { id: 'arlaInter',     label: 'Arla Intermediário',     unit: 'L'  },
  { id: 'arlaCuiaba',    label: 'Arla Tanque Cuiabá',     unit: 'L'  },
  { id: 'arlaCaminhoes', label: 'Arla Tanques Caminhões', unit: 'L'  },
  { id: 'aerem20',       label: 'Aerem EVO 20L',          unit: 'un' },
  { id: 'aerem5',        label: 'Aerem EVO 5L',           unit: 'un' },
];

export const arlaByUnit = (u) => u === 'cv' ? ARLA_CV : ARLA_SINOP;

export const CART_IDS = ['bomb20', 'bomb5', 'ibc1000', 'granel', 'aerem20', 'aerem5'];
export const EMB_ARLA_MAP = { bomb20v: 'bomb20', bomb5v: 'bomb5', ibc_vz: 'ibc1000' };

export const hasPE      = (u) => u === 'cv';
export const hasAditivo = (u) => u === 'cv';
export const embs       = (u) => u === 'cv' ? EMB_CV : EMB_SINOP;

export const fmt = (n) => Math.round(n || 0).toLocaleString('pt-BR');

export const daysAgo = (ds) => {
  const t = new Date(); t.setHours(0,0,0,0);
  return Math.round((t - new Date(ds + 'T12:00:00')) / 864e5);
};

export const getSaldo = (day, u) => {
  const peSaldo = hasPE(u)
    ? (day.pe?.saldo_ini || 0) + (day.pe?.entrada || 0) - (day.pe?.consumo || 0)
    : null;
  const aditivoSaldo = hasAditivo(u)
    ? (day.aditivo?.saldo_ini || 0) + (day.aditivo?.entrada || 0) - (day.aditivo?.consumo || 0)
    : null;
  const ureiaSaldos = getUreiaSaldos(day);
  const urSaldo = Object.values(ureiaSaldos).reduce((a, b) => a + b, 0);
  const emb = {};
  EMB_CV.forEach(e => {
    emb[e.id] = (day.emb?.[e.id]?.saldo_ini || 0) + (day.emb?.[e.id]?.entrada || 0) - (day.emb?.[e.id]?.saida || 0);
  });
  const arla = {};
  ARLA.forEach(p => {
    arla[p.id] = (day.arla?.[p.id]?.saldo_ini || 0) + (day.arla?.[p.id]?.producao || 0) - (day.arla?.[p.id]?.saida || 0);
  });
  return { peSaldo, aditivoSaldo, urSaldo, ureiaSaldos, emb, arla };
};
